module.exports = "<div class=\"columns\">\n  <div class=\"column\" app-submenu [menus]=\"menus\">\n  </div>\n</div>\n<router-outlet></router-outlet>\n  "